import React from 'react';
import { Field } from 'formik';
import InputBlock from '../inputBlock';
import * as Bixby from '$/core';
import './index.scss';

interface IBixReadonlySelectProps {
  title: string;
  fieldName: string;
  fieldId: string;
  showDefaultOption: boolean;
  isEditing?: boolean;
  options?: Bixby.Models.IIdentifiable[];
  sort?: boolean;
  required?: boolean;
}

const BixReadonlySelect: React.FC<IBixReadonlySelectProps> = props => {
  const { title, fieldName, fieldId, showDefaultOption, isEditing, options, sort, required } = props;

  const currentValue: string = (
    Bixby.Utils.find(options || [], i => i.id == fieldId) || ({} as Bixby.Models.IIdentifiable)
  ).name;

  let data = options || [];
  if (sort === undefined || sort === true) {
    data = Bixby.Utils.orderBy(options, _ => _.name);
  }

  const optionElements = data.map(provider => {
    return (
      <option value={provider.id} key={provider.id}>
        {provider.name}
      </option>
    );
  });

  return isEditing ? (
    <InputBlock title={title} required={required ?? false}>
      <Field name={fieldName} component="select" disabled={!isEditing}>
        {showDefaultOption && <option disabled selected value="" key="-1"></option>}
        {optionElements}
      </Field>
    </InputBlock>
  ) : (
    <InputBlock title={title} required={required ?? false}>
      <input type="text" value={currentValue} disabled />
    </InputBlock>
  );
};

export default BixReadonlySelect;
